import type { IconDef } from '../types';

export const document: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M19 0C20.65 0 22 1.35 22 3V21C22 22.65 20.65 24 19 24H5C3.35 24 2 22.65 2 21V3C2 1.35 3.35 0 5 0H19ZM5.44043 1.7002C4.89043 1.6802 4.42039 2.11016 4.40039 2.66016L3.61035 20.6504C3.59056 21.2002 4.02044 21.6704 4.57031 21.6904L18.5596 22.2998C19.1096 22.3198 19.5796 21.8898 19.5996 21.3398V21.3301L20.3896 3.34961C20.4094 2.79977 19.9796 2.32957 19.4297 2.30957L5.44043 1.7002ZM13.46 13.5C14.01 13.5 14.46 13.95 14.46 14.5C14.46 15.05 14.01 15.5 13.46 15.5H7C6.45 15.5 6 15.05 6 14.5C6 13.95 6.45 13.5 7 13.5H13.46ZM17 9.5C17.55 9.5 18 9.95 18 10.5C18 11.05 17.55 11.5 17 11.5H7C6.45 11.5 6 11.05 6 10.5C6 9.95 6.45 9.5 7 9.5H17ZM17 5.5C17.55 5.5 18 5.95 18 6.5C18 7.05 17.55 7.5 17 7.5H7C6.45 7.5 6 7.05 6 6.5C6 5.95 6.45 5.5 7 5.5H17Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    },
  ],
};
